// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"76617d47","787":"28c4bc0a","802":"e3418425"}[chunkId] + ".chunk.js";
};